<button mat-raised-button color="primary" class="btn-nuevo" (click)="openDialog()">
    <mat-icon>add</mat-icon>
    Nuevo inquilino
</button>